module.exports = __webpack_public_path__ + "static/media/11_5.9a5f59d1.jpg";